class AjaxCart extends HTMLElement {
  constructor() {
    super();
    this.cartDrawer = this.querySelector('cart-drawer');
    this.cartIcon = document.getElementById("cart-icon-bubble");
    this.cartIcon.addEventListener('click', this.toggle.bind(this));
    this.headerHamburger = document.querySelector(".header__icon--menu");
    this.headerHamburger.addEventListener('click', this.headerClose.bind(this));

    this.bindEvents();
  }
  
  bindEvents() {
    this.cartClose = this.querySelector('.cart__close');
    this.cartClose.addEventListener('click', this.close.bind(this));
    this.backdrop = this.querySelector('backdrop');
    this.backdrop.addEventListener('click', this.close.bind(this));
    this.swipeMove();
  }

  swipeMove() {
    let startX, startY, distX, distY
    this.querySelector('cart-drawer').addEventListener('touchstart', (e) => {
      var touchobj = e.changedTouches[0];
      startX = touchobj.pageX
      startY = touchobj.pageY
    });
    this.querySelector('cart-drawer').addEventListener('touchend', (e) => {
      var touchobj = e.changedTouches[0];
      distX = touchobj.pageX - startX 
      distY = touchobj.pageY - startY;
      if(distX > 80) {
        e.preventDefault();
        this.close();
      }
    });
  }

  toggle(event) {

    event.preventDefault();
    event.stopPropagation();
    return this.hasAttribute("open") ? this.close() : this.open();
  }
  
  open(event) {
    this.cartDrawer.classList.add('animate', 'active');
    this.setAttribute("open", "");
    document.body.classList.add(`ajax-cart-open`);
    document.documentElement.classList.add(`ajax-cart-open`);
  }

  headerClose(event) {
    if(document.body.classList.contains(`ajax-cart-open`)) {
      event.stopPropagation();
      event.preventDefault();
      this.close();
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  close() {
    this.removeAttribute("open", "");
    document.body.classList.remove(`ajax-cart-open`);
    document.documentElement.classList.remove(`ajax-cart-open`);
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('overflow-hidden-tablet');
  }

  renderContents(parsedState) {
   
    
    this.getSectionsToRender().forEach((section => {
      var section = document.getElementById(section.id);
      if(section) section.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector); 
        swiperajaxCart = new Swiper('.selectorajaxCart', {
          //  loop: true,
            slidesPerView: 1,
            navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
        });
    }));
    setTimeout(() => {
      this.open();
    }, 100);
    this.bindEvents();
  }

  getSectionsToRender() {
    
    var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
  .then(response => response.json())
  .then(data => {
   
    if(data.item_count==0){
   document.getElementById('cart-icon-bubble').innerHTML=`
 <svg
        class="icon icon-cart" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 15 17" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
            d="M5.93195 6.68789C6.24123 6.68789 6.49195 6.43717 6.49195 6.12789V4.8591H9.43649L9.43649 6.12789C9.43649 6.43717 9.68721 6.68789 9.99649 6.68789C10.3058 6.68789 10.5565 6.43717 10.5565 6.12789V4.8591H13.0311L13.8379 14.4379C13.869 14.7863 13.7529 15.1289 13.5183 15.3844C13.2837 15.6399 12.9523 15.7847 12.6054 15.7833L12.6032 15.7833H3.15528C2.80757 15.7838 2.47649 15.6381 2.24254 15.3819C2.00859 15.1257 1.89343 14.7827 1.92533 14.4373L2.79607 4.8591H5.37195L5.37195 6.12789C5.37195 6.43717 5.62267 6.68789 5.93195 6.68789ZM6.49195 3.7391H9.43649L9.43649 2.58522C9.43453 1.88728 8.86922 1.32197 8.17286 1.32001L7.75716 1.32001C7.05922 1.32197 6.49391 1.88728 6.49195 2.58365V3.7391ZM10.5565 3.7391V2.58365C10.5528 1.26803 9.48847 0.203711 8.17443 0.200014L7.75558 0.200012C6.43997 0.203711 5.37565 1.26803 5.37195 2.58207L5.37195 3.7391H2.28467C1.99504 3.7391 1.7532 3.95996 1.72697 4.2484L0.810004 14.3351C0.749188 14.9936 0.968972 15.6481 1.41548 16.1371C1.86199 16.6261 2.49388 16.9042 3.15604 16.9033H12.6021C13.2637 16.9056 13.8958 16.6292 14.3433 16.1419C14.7911 15.6542 15.0126 15.0005 14.9537 14.341L14.1039 4.2521C14.0795 3.96207 13.8369 3.7391 13.5459 3.7391H10.5565Z"
            fill="currentColor"></path>
    </svg><span class="visually-hidden" id="cartCountParent">Cart</span>
<div class="cart-count-bubble"><span aria-hidden="true" id="cartCount">${data.item_count}</span><span class="visually-hidden">1
            item</span>
    </div>

` 
      
    }
    else{
         document.getElementById('cart-icon-bubble').innerHTML=`
 <svg
        class="icon icon-cart" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 15 17" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
            d="M5.93195 6.68789C6.24123 6.68789 6.49195 6.43717 6.49195 6.12789V4.8591H9.43649L9.43649 6.12789C9.43649 6.43717 9.68721 6.68789 9.99649 6.68789C10.3058 6.68789 10.5565 6.43717 10.5565 6.12789V4.8591H13.0311L13.8379 14.4379C13.869 14.7863 13.7529 15.1289 13.5183 15.3844C13.2837 15.6399 12.9523 15.7847 12.6054 15.7833L12.6032 15.7833H3.15528C2.80757 15.7838 2.47649 15.6381 2.24254 15.3819C2.00859 15.1257 1.89343 14.7827 1.92533 14.4373L2.79607 4.8591H5.37195L5.37195 6.12789C5.37195 6.43717 5.62267 6.68789 5.93195 6.68789ZM6.49195 3.7391H9.43649L9.43649 2.58522C9.43453 1.88728 8.86922 1.32197 8.17286 1.32001L7.75716 1.32001C7.05922 1.32197 6.49391 1.88728 6.49195 2.58365V3.7391ZM10.5565 3.7391V2.58365C10.5528 1.26803 9.48847 0.203711 8.17443 0.200014L7.75558 0.200012C6.43997 0.203711 5.37565 1.26803 5.37195 2.58207L5.37195 3.7391H2.28467C1.99504 3.7391 1.7532 3.95996 1.72697 4.2484L0.810004 14.3351C0.749188 14.9936 0.968972 15.6481 1.41548 16.1371C1.86199 16.6261 2.49388 16.9042 3.15604 16.9033H12.6021C13.2637 16.9056 13.8958 16.6292 14.3433 16.1419C14.7911 15.6542 15.0126 15.0005 14.9537 14.341L14.1039 4.2521C14.0795 3.96207 13.8369 3.7391 13.5459 3.7391H10.5565Z"
            fill="currentColor"></path>
    </svg><span class="visually-hidden" id="cartCountParent">Cart</span>
<div class="cart-count-bubble"><span aria-hidden="true" id="cartCount">${data.item_count}</span><span class="visually-hidden">1
            item</span>
    </div>

`
    }
      });
    return [
      {
        id: 'ajax-cart',
        selector: `#ajax-cart`,
      },
      {
        id: 'gift-with-purchase',
        selector: '#gift-with-purchase'
      }
    ];
  }
}

customElements.define('ajax-cart', AjaxCart);